import { render, staticRenderFns } from "./resource.vue?vue&type=template&id=d8ef9da6&scoped=true&"
import script from "./resource.vue?vue&type=script&lang=js&"
export * from "./resource.vue?vue&type=script&lang=js&"
import style0 from "./resource.vue?vue&type=style&index=0&id=d8ef9da6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ef9da6",
  null
  
)

export default component.exports